import { h, Component, Fragment } from "preact";
import Config from "../config";
import Casino, { CasinoFavourites } from "../../../services/casino-feed";
import Page from "../../../services/page-data-feed";
import Session from "../utils/session";
import CasinoAppBase from "../desktop-components/casino/casino-contents";
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

import FullSite from "./full-site";

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { GameOverlay, ModalContent, ModalTop, ModalTopButton, ModalTopTitle, ModalWrapper } from "../mobile-templates/casino";
import { CloseIcon, CloseIconSlim, FavouritesFilledIcon, FavouritesHollowIcon, FavouritesIcon, FilterIcon, FullscreenIcon, UpArrowIcon } from "../utils/icons";
import PageDataFeed from "../../../services/page-data-feed";
import User from "../../../services/user";
import { Trans } from "@lingui/react/macro";
import formatCurrency from "../../../services/currency";
import { MobileCasinoMultiPage } from "./casino/mobile";
import CasinoService from "../../../services/casino-feed";


export default function CasinoRouterListener({ path, type, pageCode }) {
	return <FullSite><CasinoTemplate {...{ path, type, pageCode }} /></FullSite>;
	// return <FullSite><CasinoApp key={pageId} category={pageId} /></FullSite>;
}
function CasinoTemplate({ path, type, pageCode }) {
	type = !!type ? type : null;
	pageCode = !!pageCode ? pageCode : null;

	return <div class="bg-slate-100 text-slate-900 min-h-[inherit]">
		<MobileCasinoMultiPage {...{ path, type, pageCode }} />
	</div>
}

export class CasinoApp extends CasinoAppBase {
	getNormalOrGamesPage(chosenPage, gamePages, games) {
		const pageFromIndex = (gamePages || []).find(page => page.id == chosenPage.id);
		const currentPage = !gamePages ? chosenPage
			: !!pageFromIndex ? pageFromIndex
				: { ...chosenPage, games: games.flatMap(page => page.brands).filter(brand => brand.id.indexOf('/' + chosenPage.id) > 0).map(brand => brand.sub)[0] || [] };
		return currentPage;
	}
	render({ category }) {
		const currentPage = this.getNormalOrGamesPage(this.state.currentPage, this.state.gamePages, this.state.games);
		return (
			<div class="bg-slate-100 text-slate-900 min-h-[inherit]">
				<Carousel />
				<OpenSearchPageButton />
				<GamesPagePicker pages={this.state.gamePages} games={this.state.games} currentPage={currentPage} onChange={(page) => this.setState({ currentPage: page })} />
				<GamesList pages={this.state.gamePages} games={this.state.games} currentPage={currentPage} onChange={(page) => this.setState({ currentPage: page })} />
				<CasinoSearchPopup />
			</div>
		);
	}
}

function OpenSearchPageButton({ onSearchOpen }) {
	return (
		<div class="bg-blue-whale-700 text-white flex h-12 items-center justify-between text-base" onClick={(e) => (window.location.hash = CasinoSearchPopup.CASINO_SEARCH_HASH)}>
			<div class="flex gap-2 h-full items-center px-3 text-blue-whale-50">
				<div class="flex h-full items-center py-3">
					<SearchIcon />
				</div>
				<span>Search for a game!</span>
			</div>
			<div class="flex h-full items-center justify-center aspect-square border-l border-blue-whale-600 text-blue-whale-50"><FilterIcon class="h-6" /></div>
		</div>
	);
}

function GamesPagePicker({ pages, games, currentPage, onChange }) {
	return (
		<div class="h-14 bg-blue-whale-800 text-blue-whale-50 py-1">
			<div class="h-full overflow-x-auto overflow-y-hidden border-b-2 border-dashed border-blue-whale-400 py-2 px-2">
				<div class="flex h-full items-center gap-2 text-sm">
					<div class="h-8 w-8 py-2 shrink-0 rounded-full border flex items-center justify-center">
						<HeartIcon />
					</div>
					{pages
						.filter((page) => page.id == "all" || (page.games && !!page.games.length))
						.map((page) => (
							<div class={"mx-1 shrink-0 border-b-2 " + (page.id == currentPage.id ? "border-b-yellow-500" : "border-transparent text-blue-whale-50")} onClick={(e) => onChange(page)}>
								{page.name}
							</div>
						))}
				</div>
			</div>
		</div>
	);
}

export class Carousel extends Component {
	state = { slides: null }
	componentWillMount() {
		Page.getCarousel().then(data => {
			this.setState({ slides: data['casino-promo'] })
		})
	}
	render() {
		if (this.state.slides == null)
			return;

		const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start' }, [Autoplay()])

		return (
			<div class="h-32 w-full overflow-x-hidden">
				<div class="embla h-full" ref={emblaRef}>
					<div class="embla__container h-full will-change-transform">
						{this.state.slides.map(slide => (<div class="grow-0 shrink-0 w-full">
							<div class="relative h-full w-full">
								<div class="h-full w-full shrink-0 bg-cover bg-left" style={"background-image:url('" + (Config.softionAPI + slide.img) + "')"}></div>
								{!!slide.title && <div class="absolute w-1/2 top-0 bottom-0 right-0 bg-linear-to-r from-black/0 via-black/80 to-black">
									<div class="absolute top-1/2 -translate-y-1/2 text-white drop-shadow-xl text-sm right-1">
										<div class="text-sm drop-shadow">{slide.title}</div>
										<div class="text-xs drop-shadow">{slide.subtitle}</div>
									</div>
								</div>}
							</div>
						</div>))}
					</div>
				</div>
			</div>
		)
	}
}
function Carousel_() {
	const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'le' }, [Autoplay()])

	return (
		<div class="h-32 w-full overflow-x-hidden">
			<div class="embla h-full" ref={emblaRef}>
				<div class="embla__container h-full will-change-transform">
					<div class="grow-0 shrink-0 w-full">
						<div class="relative h-full w-full">
							<div class="h-full w-full shrink-0 bg-cover bg-left" style={"background-image:url('" + require('url:../assets/img/casino/aviator-banner.jpg') + "')"}></div>
						</div>
					</div>
					<div class="grow-0 shrink-0 w-full">
						<div class="relative h-full w-full">
							<div class="h-full w-full shrink-0 bg-cover bg-left" style={"background-image:url('" + require('url:../assets/img/casino/pragmatic-slots.jpg') + "')"}></div>
						</div>
					</div>
					<div class="grow-0 shrink-0 w-full">
						<div class="relative h-full w-full">
							<div class="h-full w-full shrink-0 bg-cover bg-left" style={"background-image:url('" + require('url:../assets/img/casino/default-slide.png') + "')"}></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export class GamesList extends Component {
	render({ games, currentPage, pages, onChange }) {
		if (currentPage.id == "all")
			return <AllGames pages={pages} games={games} onChange={onChange} />;

		return (
			<div class="">
				<div class="flex items-center justify-between px-4 py-2">
					<div class="text-lg">{currentPage.name}</div>
					<div class="hidden">
						(Y)<span class="inline-block px-1">Sort By</span>,
					</div>
				</div>
				<div class="grid grid-cols-3 gap-2 px-2">
					{currentPage.games && currentPage.games.map((game) => (
						<GameIcon game={game} />
					))}
				</div>
			</div>
		);
	}

	getCatalog(games) {
		return Casino.flattenSlotList();
	}
}

function AllGames({ games, pages, onChange }) {
	const previews = pages.filter((page) => page.id != "all" && page.games.length != 0);
	if (previews.length == 0)
		return <SkeletonGamesPreview />;
	return previews.map((page) => <GamesPreview page={page} games={games} onChange={onChange} />);
}

export class GamesPreview extends Component {
	rndIndex = Math.floor(Math.random() * 15);

	render({ games, page, onChange }) {
		const columns = page.bigPreviews ? 2 : 3;

		// Due righe fisse, in base al numero di colonne
		const gamesCatalog = this.getPreviewCatalog(page.games).slice(0, 2 * columns);
		if (!gamesCatalog || !gamesCatalog.length)
			return null;

		return (
			<div class="pb-4" key={page.id}>
				<div class="flex items-center justify-between px-4 py-4 pt-2">
					<div class="text-lg">{page.name}</div>
					<div class="">
						<div onClick={(e) => onChange(page)} class="rounded-full bg-sky-600 text-white w-8 h-8 py-2 flex items-center justify-center text-xs">
							<ChevronRight class="my-.5" />
						</div>
					</div>
				</div>
				<div data-large={page.bigPreviews} class="grid gap-2 px-2 grid-cols-3 data-[large=true]:grid-cols-2">
					{gamesCatalog.map((game) => (
						<GameIcon game={game} />
					))}
				</div>
			</div>
		);
	}

	_getPreviewCatalog(games) {
		return !games ? [] : games.slice(this.rndIndex, this.rndIndex + 6);
	}

	getPreviewCatalog(games) {
		return !games ? [] : games.slice(0, 6);
	}
}

function SkeletonGamesPreview() {
	return (
		<div class="pb-4">
			<div class="flex items-center justify-between px-4 py-4 pt-2">
				<div class="text-lg"><Skeleton width={150} /></div>
				<div class="">
					<div class="rounded-full bg-sky-600 text-white w-8 h-8 py-2 flex items-center justify-center text-xs">
						<ChevronRight class="my-.5" />
					</div>
				</div>
			</div>
			<div class="grid grid-cols-3 gap-2 px-2">
				<SkeletonGameIcon />
				<SkeletonGameIcon />
				<SkeletonGameIcon />
				<SkeletonGameIcon />
				<SkeletonGameIcon />
				<SkeletonGameIcon />
			</div>
		</div>
	);
}

function SkeletonGameIcon() {
	return <a class="flex aspect-square flex-col gap-0.5 pb-1">
		<div class="w-full rounded-lg grow shrink object-cover object-center bg-blue-whale-700 h-0 min-h-12.5 flex items-stretch justify-stretch">
			<Skeleton containerClassName="flex-1" height="100%" style={{ top: '-4px' }} />
		</div>
		<div class="text-xs truncate"><Skeleton /></div>
	</a>
}

export class GameIcon extends Component {
	getLink(game) {
		if (Session.isActive())
			return game.play;
		return "#login";
	}
	openGame(game) {
		if (Session.isActive())
			return PageDataFeed.setCurrentGame(game);
		location.hash = "#login";
		return;
	}
	getImgUrl(imgUrl) {
		if (!imgUrl || imgUrl.indexOf("://") < 0) {
			return imgUrl;
		}
		return "https://img-res.ltngame.tools/unsafe/300x0/" + encodeURIComponent(imgUrl.replace(/https?:\/\//, ""));
	}
	render({ game }) {
		return (
			<a key={[game.provider, game.brand, game.id].join("")} class="flex aspect-square flex-col gap-0.5 pb-1" href="javascript:void(0);" onClick={e => this.openGame(game)}>
				<img class="w-full rounded-lg grow shrink object-cover object-center bg-blue-whale-700 h-0 min-h-12.5" src={this.getImgUrl(game.logo)} loading="lazy" />
				<div class="text-xs truncate">{game.name}</div>
			</a>
		);
	}
}

export class CasinoSearchPopup extends Component {
	static CASINO_SEARCH_HASH = "#search-game";

	state = {
		open: window.location.hash == CasinoSearchPopup.CASINO_SEARCH_HASH,
		name: "",
		provider: "",
		brand: "",
		games: Casino.flattenSlotList(),
		collapsed: true
	};

	componentWillMount() {
		window.addEventListener("hashchange", (e) => {
			this.setState({
				open: window.location.hash == CasinoSearchPopup.CASINO_SEARCH_HASH,
			});
		});
		Casino.listenChanges(() => {
			this.setState({ games: Casino.flattenSlotList() });
		});
	}

	filterByName(name) {
		this.setState({ name: name });
	}

	filterByProvider(provider) {
		this.setState({ provider: this.state.provider == provider ? "" : provider });
	}

	filterByBrand(provider, brand) {
		const isIdentical = provider + "/" + brand == this.state.provider + "/" + this.state.brand;
		this.setState({
			brand: isIdentical ? "" : brand,
			provider: isIdentical ? "" : provider,
		});
	}

	isSelected(provider, brand) {
		return this.state.provider == provider.id && this.state.brand == brand.id;
	}

	render() {
		return (
			<div id="casino-search-popup" class={"fixed z-10 inset-0 h-screen overflow-y-auto bg-blue-whale-800 text-white " + (this.state.open ? "" : " hidden")}>
				<div class="flex h-12 items-center justify-between bg-blue-whale-700 text-base">
					<div class="flex gap-2 px-3 text-blue-whale-50 h-full items-center w-full min-w-0">
						<div class="flex h-full items-center py-3">
							<SearchIcon />
						</div>
						<input placeholder="Search for a game!" class="h-full grow w-full bg-transparent text-white" onInput={(e) => this.filterByName(e.target.value)} />
					</div>
					<div class="flex h-full items-center justify-center aspect-square border-l border-blue-whale-600 text-blue-whale-50"><FilterIcon class="h-6" /></div>
					<div class="flex h-full items-center justify-center aspect-square border-l border-blue-whale-600 text-blue-whale-50" onClick={e => window.location.hash = ''}><CloseIconSlim class="h-6" /></div>
				</div>
				<div class="fn-filter-1 px-4 py-3">
					<div class="flex items-center justify-between pb-2">
						<div class="">Brands</div>
						<div onClick={e => this.setState({ collapsed: !this.state.collapsed })}>
							<UpArrowIcon class={"h-4 transition-transform " + (this.state.collapsed ? "rotate-180" : "")} />
						</div>
					</div>
					{this.state.collapsed ? null : <div class="flex flex-wrap gap-2">
						{this.state.games &&
							Object.values(Casino.providersList())
								.map((brand) => (
									<div
										class={"rounded-full grow text-center py-1 px-2 text-white text-xs whitespace-nowrap " + (this.isSelected({ id: brand.provider }, { id: brand.id }) ? "bg-blue-whale-600" : "bg-blue-whale-900")}
										onClick={(e) => this.filterByBrand(brand.provider, brand.id)}
									>
										{brand.name}
									</div>
								))}
					</div>}
				</div>
				<div class="fn-games-list px-4 py-2 grid grid-cols-2 gap-2">
					{this.state.games &&
						this.state.games
							.filter((p) => (!this.state.provider || p.provider == this.state.provider)
								&& (!this.state.brand || p.category == this.state.brand))
							.filter((g) => g.name.toLowerCase().indexOf(this.state.name.toLowerCase()) >= 0)
							.slice(0, 20)
							.map((game) => <GameIcon game={game} />)}
				</div>
			</div>
		);
	}
}

function SearchIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="fill-current h-full">
			<path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path>
		</svg>
	);
}

function HeartIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="fill-current h-full">
			<path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" />
		</svg>
	);
}

function ChevronRight(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class={"fill-current h-full " + (props.class || "")}>
			<path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
		</svg>
	);
}


export class PopupGame extends Component {
	state = {
		/** @type {import("../../../services/casino-feed").GameEntry | null} */
		game: null
	}

	componentWillMount() {
		PageDataFeed.listenCurrentGame(this.onGameOpen = () => {
			this.reloadOpenedGame();
		})
		this.reloadOpenedGame();
	}
	componentWillUnmount() {
		PageDataFeed.stopListenCurrentGame(this.onGameOpen);
	}

	reloadOpenedGame() {
		/** @type {import("../../../services/casino-feed").GameEntry | null} */
		const current = PageDataFeed.data['current-game'];
		this.setState({ game: current });
	}

	toggleFavourite = e => {
		if (CasinoFavourites.isFavourite(this.state.game))
			CasinoFavourites.removeFavourite(this.state.game)
		else
			CasinoFavourites.addFavourite(this.state.game)
		this.setState({})
	}

	render() {
		if (this.state.game == null)
			return null;
		const playUrl = CasinoService.getPlayUrl(this.state.game.provider, this.state.game.category, this.state.game.id);
		return <GameOverlay>
			<ModalWrapper>
				<ModalTop>
					<ModalTopTitle>{this.state.game.name}</ModalTopTitle>
					<div class="px-1 py-px text-xs rounded bg-slate-50 border border-slate-300">
						<div class="truncate text-2xs text-right"><Trans>Bonus</Trans>{"🎁"}</div>
						<div class="w-full text-right">{formatCurrency(parseFloat(User.bonus()))}</div>
					</div>
					<ModalTopButton onClick={this.toggleFavourite}>
						{CasinoFavourites.isFavourite(this.state.game)
							? <FavouritesFilledIcon class="h-4" />
							: <FavouritesHollowIcon class="h-4" />}
					</ModalTopButton>
					<ModalTopButton onClick={e => this.iframe.requestFullscreen()}><FullscreenIcon class="h-4" /></ModalTopButton>
					<ModalTopButton onClick={e => PageDataFeed.setCurrentGame(null)}><CloseIcon class="h-4" /></ModalTopButton>
				</ModalTop>
				<ModalContent>
					<iframe style="width:100%;height:100%;border:0;margin:0;padding:0;" key={playUrl} src={playUrl} ref={ref => this.iframe = ref} />
				</ModalContent>
			</ModalWrapper>
		</GameOverlay>
	}
}